// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"96453bf2","251":"9e94543a","717":"ceb3b654","876":"0b984637"}[chunkId] + ".css";
};